import axios from "axios";
import ProfileJPG from "../assets/images/profile.jpg";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
});

async function fetchProfile(token, subject = null) {
  try {
    const response = await API.post("/myprofile", { token });
    // const response = {
    //   data: [
    //     { id: 1, name: "Priya", email: "priya@gmail.com", image: ProfileJPG},
    //   ],
    // };
    return response.data;
  } catch (error) {
    console.error("Error fetching subjects:", error);
    throw error;
  }
}

export { fetchProfile };
